import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-patient-identification-labels',
    templateUrl: './patient-identification-labels.component.html',
    styleUrls: ['./patient-identification-labels.component.scss'],
    standalone: false
})
export class PatientIdentificationLabelsComponent {
  @Input() patientName: string;
  @Input() patient: any;
  @Input() userOwnerID: string;

  constructor() {}
}

